import styled, { css } from 'styled-components';

interface WrapperLinePropsInterface {
  isFirstPrint: boolean;
}

export const WrapperLine = styled.div<WrapperLinePropsInterface>`
  ${({ theme, isFirstPrint }) => css`
    display: inline-flex;
    position: relative;

    ${!isFirstPrint &&
    css`
      ::before {
        content: '';
        position: absolute;
        width: 1px;
        height: calc(100% - 26px);
        background: ${theme.color.border.neutral.default};
        left: 50%;
        bottom: ${theme.spacing.km0};
      }
    `}
  `}
`;
